import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives/directives.module';
import { AutocompleteComponent } from './autocomplete.component';

@NgModule({
    imports: [TwcModule, ReactiveFormsModule, FormsModule, CommonModule, TranslateModule, DirectivesModule],
    declarations: [AutocompleteComponent],
    exports: [AutocompleteComponent],
})
export class AutocompleteModule {}
